/**
 * UniverseProvider — wraps children with the active universe context.
 * Placed inside AuthProvider so useEffectiveTenantId is available.
 */
import { useState, useCallback, useMemo } from 'react';
import { UniverseContext, useUniverses, Universe } from '@/hooks/useUniverses';

export default function UniverseProvider({ children }: { children: React.ReactNode }) {
  const { universes, isLoading } = useUniverses();
  const [activeUniverse, setActiveUniverse] = useState<Universe | null>(null);

  const handleSet = useCallback((u: Universe | null) => setActiveUniverse(u), []);

  const value = useMemo(
    () => ({
      universes,
      activeUniverse,
      setActiveUniverse: handleSet,
      isLoading,
    }),
    [universes, activeUniverse, handleSet, isLoading],
  );

  return <UniverseContext.Provider value={value}>{children}</UniverseContext.Provider>;
}
